import { For } from "solid-js";
import { IoLanguageOutline } from "solid-icons/io";
import { useI18n } from "./i18n";
import { language, setLanguage, supportedLanguages, languageLabels } from "./App";

const LanguageSelector = () => {
  const i18n = useI18n();

  return (
    <div class="ui-dropdown ui-dropdown-end">
      <button tabindex="0" class="ui-btn ui-btn-ghost" title={i18n.t("Change language")}>
        <IoLanguageOutline size={20} />
      </button>
      <ul tabindex="-1" class="ui-dropdown-content ui-menu bg-base-100 rounded-box z-10 w-52 p-2 shadow-sm">
        <For each={supportedLanguages}>
          {(lang) => (
            <li>
              <button
                class="text-sm"
                classList={{
                  "ui-menu-active": lang === language(),
                }}
                onClick={() => setLanguage(lang)}
              >
                {languageLabels.get(lang)}
              </button>
            </li>
          )}
        </For>
      </ul>
    </div>
  );
};

export default LanguageSelector;
